module.exports = __webpack_public_path__ + "img/招标公告.ddd29ab0.jpg";